import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';

import {Divider, Layout} from '@phonectas/unifon-ui-kit';
import TextWithLabel from 'common/components/TextWithLabel';
import {ZendeskCase} from 'common/types/store/threeSixtyTypes';
import GridLayout from 'common/components/GridLayout';
import {StyledLabel} from 'common/components/TextDivWithLabel/styled';
import Badges from 'common/components/Badges';
import TextDivWithLabel from 'common/components/TextDivWithLabel';
import {DATE_FORMATS, getDateByCustomFormat} from 'utils/date';

interface ZendeskContentProps {
    data: ZendeskCase | null;
    onClick?: (item: ZendeskCase) => void;
}

const ZendeskContent: React.FC<ZendeskContentProps> = ({
	data,
	// onClick,
}) => {
	const [t] = useTranslation();
	// const handleRowClick = useCallback(() => {
	//     if (data && onClick) {
	//     onClick(data);
	//     }
	// }, [onClick, data]);
	const handleZendeskLink = useCallback((e: React.SyntheticEvent) => {
		e.stopPropagation();
		const zendeskUrl = `https://unifon.zendesk.com/agent/tickets/${data?.case_id}`;
		window.open(zendeskUrl, '_blank');
	}, [data?.case_id]);

	return (
		<>
			<Divider />
			<Layout
				direction="column"
				fullWidth
				nowrap
				style={{marginTop: '10px'}}
			>
				<GridLayout>
					<Layout>
						<TextWithLabel
							label={t('Queues')}
							text={data?.group || ''}
						/>
					</Layout>
					<Layout>
						<TextWithLabel
							label={t('Status')}
							text={data?.status || ''}
						/>
					</Layout>
					<Layout direction="column" gap="none">
						<StyledLabel>{t('SLA')}</StyledLabel>
						{data?.sla ? <Badges data={data?.sla} /> : 'N/A'}
					</Layout>
					<Layout direction="column" gap="none">
						<TextWithLabel
							label={t('Created')}
							text={getDateByCustomFormat(data?.ze_created_at, DATE_FORMATS.DD_MM_YY)}
						/>
					</Layout>
					<Layout direction="column" gap="none">
						<TextWithLabel
							label={t('Updated')}
							text={getDateByCustomFormat(data?.ze_updated_at, DATE_FORMATS.DD_MM_YY)}
						/>
					</Layout>
				</GridLayout>
				<GridLayout>
					<Layout>
						<TextWithLabel
							label={t('Owner')}
							text={data?.submitter?.name || 'N/A'}
						/>
					</Layout>
					<Layout>
						<TextWithLabel
							label={t('Client')}
							text={data?.assignee?.name || 'N/A'}
						/>
					</Layout>
					<Layout direction="column" gap="none">
						<StyledLabel>{t('Link')}</StyledLabel>
						<span onClick={handleZendeskLink} style={{cursor: 'pointer', textDecoration: 'underline', color: '#004BED'}}>
                            Zendesk
						</span>
					</Layout>
				</GridLayout>
				<Divider />
				<Layout direction="row" fullWidth>
					<TextDivWithLabel
						text={data?.subject ?? ''}
						label={t('Description')}
					/>
				</Layout>
				{/* <Layout direction="row"></Layout>
                <Layout direction="row"></Layout> */}
			</Layout>
		</>
	);
}

export default ZendeskContent;